var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34249 0.610885L12.9995 6.26788L11.5855 7.68188L6.63548 2.73188L1.68548 7.68188L0.271484 6.26788L5.92848 0.610885C6.11601 0.423414 6.37032 0.318099 6.63548 0.318099C6.90065 0.318099 7.15496 0.423414 7.34249 0.610885Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowUp);
export default __webpack_public_path__ + "static/media/blackArrowUp.62d255d2df891354c66f448d1411bc7a.svg";
export { ForwardRef as ReactComponent };